
import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'
export default Vue.extend({
  props: {
    identifier: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      mapId: null
    }
  },
  methods: {
    generateRandomId() {
      this.mapId = `mapContainer-${uuidv4()}`
    }
  }
})
